import api, { unwrap } from './client';

// Lignes de crédit à période (Autres paramètres). La limite mensuelle cumulée est
// dérivée côté serveur et synchronisée dans financials_cash_actuals.credit_line.
export const listCreditLines     = (tid)        => unwrap(api.get(`/financials/credit-lines/${tid}`));
export const effectiveCreditLine = (tid, year)  => unwrap(api.get(`/financials/credit-lines/${tid}/effective`, { params: { year } }));
export const createCreditLine    = (tid, data)  => unwrap(api.post(`/financials/credit-lines/${tid}`, data));
export const updateCreditLine    = (tid, id, d) => unwrap(api.patch(`/financials/credit-lines/${tid}/${id}`, d));
export const deleteCreditLine    = (tid, id)    => unwrap(api.delete(`/financials/credit-lines/${tid}/${id}`));
